import ApiMexx2Face from './apiMexx2Face';
import { Auth } from 'aws-amplify';

export const createFaceLivenessSession = async _ => { 
  let data = []
  await ApiMexx2Face.get(`/faceliveness/create-session`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const getFaceLivenessCredentials = async _ => {
  let data = []
  await ApiMexx2Face.get(`/faceliveness/credentials`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

// 14/10/2026: o login Cognito do liveness saiu do navegador (usuário/senha estavam no bundle). A 2Face faz o login e devolve o
// id_token; aqui o Amplify recebe esse token via federatedSignIn e troca por credencial no identity pool, exatamente como fazia
// depois do Auth.signIn — o detector (1.0.7) não muda. A API devolve JSON em minúsculas.
export const signInLivenessFederated = () => {
  return getFaceLivenessCredentials().then(result => {
    const c = result && result.success && result.data ? result.data : null
    if (!c) throw new Error("Serviço de verificação de vida indisponível")
    const provider = c.provider
    const token = c.idtoken ?? c.idToken
    const expiresAt = Number(c.expiresatunixms ?? c.expiresAtUnixMs)
    if (!provider || !token || !expiresAt) throw new Error("Serviço de verificação de vida indisponível")
    return Auth.federatedSignIn(provider, { token: token, expires_at: expiresAt }, { name: 'mexx-liveness' })
  })
}

export const getFaceLivenessSessionResult = async sessionId => { 
  let data = []
  await ApiMexx2Face.get(`/faceliveness/get-session-result/${sessionId}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const cancelFaceLivenessSession = async sessionId => { 
  let data = []
  await ApiMexx2Face.get(`/faceliveness/cancel-session/${sessionId}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const restartFaceLivenessSession = async sessionId => { 
  let data = []
  await ApiMexx2Face.get(`/faceliveness/restart-session/${sessionId}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}